const COLLECTION_CAROUSEL_MIN_PERCENT = 20;

class CollectionCarouselProgress extends HTMLElement {
  connectedCallback() {
    this.slider = document.getElementById(this.dataset.sliderId);
    this.bar = this.querySelector('.collection-carousel__progress-bar');

    if (!this.slider || !this.bar) return;

    this.update = this.update.bind(this);
    this.slider.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);
    new ResizeObserver(this.update).observe(this.slider);

    this.enableDragToScroll();

    this.update();
  }

  update() {
    const scrollWidth = this.slider.scrollWidth;
    const clientWidth = this.slider.clientWidth;
    const scrollableWidth = scrollWidth - clientWidth;

    let percent = 100;
    if (scrollableWidth > 0) {
      const scrollRatio = this.slider.scrollLeft / scrollableWidth;
      percent = COLLECTION_CAROUSEL_MIN_PERCENT + scrollRatio * (100 - COLLECTION_CAROUSEL_MIN_PERCENT);
    }

    this.bar.style.width = `${percent}%`;
  }

  enableDragToScroll() {
    const slider = this.slider;
    let isDown = false;
    let dragged = false;
    let startX = 0;
    let startScrollLeft = 0;

    // Prevent the browser's native "drag an image/link" gesture from hijacking
    // the mouse-down so our scroll-drag below actually receives the moves.
    slider.querySelectorAll('img, a').forEach((el) => {
      el.setAttribute('draggable', 'false');
    });

    const onPointerDown = (event) => {
      isDown = true;
      dragged = false;
      startX = event.pageX;
      startScrollLeft = slider.scrollLeft;
      slider.classList.add('is-dragging');
      this.classList.add('is-dragging');
    };

    const onPointerMove = (event) => {
      if (!isDown) return;
      const delta = event.pageX - startX;
      if (Math.abs(delta) > 5) dragged = true;
      if (dragged) event.preventDefault();
      slider.scrollLeft = startScrollLeft - delta;
    };

    const onPointerUp = () => {
      isDown = false;
      slider.classList.remove('is-dragging');
      this.classList.remove('is-dragging');
    };

    slider.addEventListener('mousedown', onPointerDown);
    slider.addEventListener('dragstart', (event) => event.preventDefault());
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);

    slider.addEventListener(
      'click',
      (event) => {
        if (dragged) {
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }
      },
      true
    );
  }
}

if (!customElements.get('collection-carousel-progress')) {
  customElements.define('collection-carousel-progress', CollectionCarouselProgress);
}
